import colorGame from "../assets/project-pics/colorgame.png";
import nameit from "../assets/project-pics/nameit.jpg";
import flashType from "../assets/project-pics/flashtype.png";
import klimate from "../assets/project-pics/weather-app.png";
import BMS from "../assets/project-pics/BMS.png";
import AIEmail from "../assets/project-pics/AI-email.png";
import MachineCoding from "../assets/project-pics/machine-coding.png";

export const projectsData = [
  {
    projectName: "ColorGame",
    projectDescription:
      "RGB code of an unknown colour will be given for e.g- RGB (255, 0, 0) and you have to guess the right colour out of random colours by clicking on them. Super cool right!",
    imageUrl: colorGame,
    projectUrl: "https://anupam-coder.github.io/ColorGame/",
  },
  {
    projectName: "Name It!",
    projectDescription:
      "Do you find it difficult to name your projects or ventures? Fear not! Check out this cool name suggestion application which will help you find the best name for your next project, venture, or startup. Keep building!",
    imageUrl: nameit,
    projectUrl: "https://anupam-coder.github.io/Name_search/",
  },
  {
    projectName: "FlashType",
    projectDescription:
      "Having a good typing speed will always help you as a developer! Here, I present you the typing speed test application, where you can check your typing speed (in wpm) and share the results with your friends too.",
    imageUrl: flashType,
    projectUrl: "https://anupam-coder.github.io/TypeLikeFlash/",
  },
  {
    projectName: "Klimate Weather App",
    projectDescription:
      "The Weather App provides real-time weather updates, including temperature, humidity, and forecasts for any location.",
    imageUrl: klimate,
    projectUrl: "https://klimate-weather-app-six.vercel.app/",
  },
  {
    projectName: "Book My Show",
    projectDescription:
      "Developed a Book My Show web application using the MERN stack. Key features include allowing partners to add theaters, admins to manage movie listings, and other functionalities to enhance user experience.",
    imageUrl: BMS,
    projectUrl: "https://bookmyshow-u020.onrender.com/",
  },
  {
    projectName: "AI Email Asistant",
    projectDescription:
      "🚀 I built a free, open-source AI Email Assistant using React + OpenRouter API to help you write better emails effortlessly.✉️ From leave requests to persuasive pitches — choose a tone, generate text, and copy with a click (plus confetti!).",
    imageUrl: AIEmail,
    projectUrl: "https://ai-email-asistant.vercel.app/",
  },
  {
    projectName: "Machine Coding Examples",
    projectDescription:
      "This repository contains various machine coding examples that demonstrate the implementation of UI components. It serves as a resource for developers looking to enhance their machine coding skills.",
    imageUrl: MachineCoding,
    projectUrl: "https://developer-practice.vercel.app/",
  },
];
